import { MASSIVE_M } from "./types.js";

export const ACTION_SET_PROCESS_STATE = `${MASSIVE_M}ACTION_SET_PROCESS_STATE`;
export const ACTION_SET_SELECTED_FILE = `${MASSIVE_M}ACTION_SET_SELECTED_FILE`;
export const ACTION_SET_UPLOAD_PROGRESS = `${MASSIVE_M}ACTION_SET_UPLOAD_PROGRESS`;
export const ACTION_SET_VALIDATION_RESULT = `${MASSIVE_M}ACTION_SET_VALIDATION_RESULT`;
export const ACTION_SET_PROCESS_RESULT = `${MASSIVE_M}ACTION_SET_PROCESS_RESULT`;
export const ACTION_SET_UPLOAD_DRAWER_OPEN = `${MASSIVE_M}ACTION_SET_UPLOAD_DRAWER_OPEN`;
export const ACTION_SET_DELETE_DRAWER_OPEN = `${MASSIVE_M}ACTION_SET_DELETE_DRAWER_OPEN`;
export const ACTION_SET_CURRENT_STEP = `${MASSIVE_M}ACTION_SET_CURRENT_STEP`;
export const ACTION_SET_ERRORS = `${MASSIVE_M}ACTION_SET_ERRORS`;
export const ACTION_MASSIVE_UPLOAD = `${MASSIVE_M}ACTION_MASSIVE_UPLOAD`;
export const ACTION_MASSIVE_DELETE = `${MASSIVE_M}ACTION_MASSIVE_DELETE`;
export const ACTION_DOWNLOAD_TEMPLATE = `${MASSIVE_M}ACTION_DOWNLOAD_TEMPLATE`;
export const ACTION_DOWNLOAD_DELETE_TEMPLATE = `${MASSIVE_M}ACTION_DOWNLOAD_DELETE_TEMPLATE`;
export const ACTION_RESET_PROCESS = `${MASSIVE_M}ACTION_RESET_PROCESS`;
